var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"formRef",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }